import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { CustomCart } from '@cart/const';
import { BonusWidgetComponent, SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { BonusSystemFeatureAvailableService } from '@user/feature';

@Component({
  selector: 'sd-cart-totals-order',
  imports: [SdvorButtonComponent, RouterLink, BonusWidgetComponent],
  templateUrl: './cart-totals-order.component.html',
  styleUrls: ['./cart-totals-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartTotalsOrderComponent {
  readonly cart = input.required<CustomCart>();

  protected readonly isBonusFeatureAvailableForUser = toSignal(
    inject(BonusSystemFeatureAvailableService).isFeatureAvailableForUser(),
    { initialValue: false },
  );

  protected readonly bonusAssignedAmount = computed(() => {
    if (!this.isBonusFeatureAvailableForUser()) {
      return undefined;
    }

    return this.cart()?.bonus?.assignedAmountInfo?.formattedValue;
  });
}
